module.exports = __webpack_public_path__ + "media/rating/yes-675de6b5.svg";